module.exports = __webpack_public_path__ + "img/tagalys.d326c0d7.png";